import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CalendarClock } from "lucide-react";

export default function FloatingBook() {
  const [show, setShow] = useState(false);
  const [inBooking, setInBooking] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const el = document.getElementById("booking");
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => setInBooking(entry.isIntersecting),
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const visible = show && !inBooking;

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href="/#booking"
          data-testid="fab-book-appointment"
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="lg:hidden fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-accent text-accent-foreground pl-2 pr-5 py-2 font-bold text-sm"
          style={{ boxShadow: "0 18px 40px -12px rgba(228,71,122,0.55)" }}
        >
          <span className="w-10 h-10 rounded-full bg-white/15 grid place-items-center backdrop-blur-sm">
            <CalendarClock size={17} />
          </span>
          Reserve a slot
        </motion.a>
      )}
    </AnimatePresence>
  );
}
